"use client";

import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { css, sva } from "@/../styled-system/css";

const progress = sva({
  slots: ["root", "indicator"],
  base: {
    root: {
      position: "relative",
      h: "2",
      w: "full",
      overflow: "hidden",
      backgroundColor: "zinc.100",
    },
    indicator: {
      h: "full",
      w: "full",
      flex: "1",
      backgroundColor: "sky.400",
      transition: "all",
    },
  },
});

const { root, indicator } = progress.raw();

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    css?: object;
  }
>(({ css: cssProp = {}, value, ...props }, ref) => {
  const className = css(root, cssProp);
  return (
    <ProgressPrimitive.Root ref={ref} className={className} {...props}>
      <ProgressPrimitive.Indicator
        className={css(indicator)}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export default Progress;
